import React from "react";
import { Reveal } from "@/components/common/Reveal";

// Editorial section heading with eyebrow + numbered chapter option.
export default function SectionHeading({
  eyebrow,
  chapter,
  title,
  intro,
  align = "left",
  invert = false,
  className = "",
}) {
  const alignCls = align === "center" ? "text-center mx-auto items-center" : "text-left items-start";
  return (
    <div className={`flex flex-col ${alignCls} max-w-3xl ${className}`}>
      {(eyebrow || chapter) && (
        <Reveal className="mb-4 flex items-center gap-3">
          {chapter && (
            <span className={`font-heading font-extrabold text-[13px] tracking-widest ${invert ? "text-copper" : "text-copper"}`}>
              {chapter}
            </span>
          )}
          {eyebrow && (
            <span className={`text-[12px] font-semibold uppercase tracking-[0.18em] ${invert ? "text-white/60" : "text-teal"}`}>
              {eyebrow}
            </span>
          )}
        </Reveal>
      )}
      {title && (
        <Reveal delay={0.05}>
          <h2 className={`font-heading font-bold tracking-tight text-[30px] leading-[36px] md:text-[38px] md:leading-[44px] lg:text-[44px] lg:leading-[52px] ${invert ? "text-white" : "text-navy"}`}>
            {title}
          </h2>
        </Reveal>
      )}
      {intro && (
        <Reveal delay={0.1}>
          <p className={`mt-5 text-[17px] leading-[28px] lg:text-[19px] lg:leading-[30px] ${invert ? "text-white/70" : "text-muted-foreground"}`}>
            {intro}
          </p>
        </Reveal>
      )}
    </div>
  );
}
